import { comingUpExamination } from "./comingUpExamination";
import { newEmploye } from "./newEmploye";
import { bereichExamination } from "./bereichExamination";
import { angebotExamination } from "./angebotExamination";

const triggers = {newEmploye, comingUpExamination, bereichExamination, angebotExamination}

export default triggers;
